export default __webpack_public_path__ + "static/media/Group1551@2x.6de5a376.png";